import { Component, OnInit } from '@angular/core';
import { LiftDetail } from '../../models/lift-detail.model';
import { ActivatedRoute } from '@angular/router';
import { LiftBoardParameterService } from '../../services/lift-board-parameter.service';
import { LiftBoardParameterCriteria } from '../../models/lift-board-parameter.criteria';
import { LoginService } from '../../../user/services/login.service';

@Component({
  selector: 'app-lift-parameters',
  templateUrl: './lift-parameters.component.html',
  styleUrls: ['./lift-parameters.component.css']
})
export class LiftParametersComponent implements OnInit {
  menu = 'param';
  lift: LiftDetail;
  liftId: number;
  groups: any[] = [];
  params: any[] = [];

  selectedParam: any = {
    liftParameter: {
      code: 'default',
      description: 'Není vybrán žádný parametr!',
      type: 3
    }
  };

  //Permissions
  canViewErrors: boolean = false;
  canView: boolean = false;
  canControl: boolean = false;
  canViewParameter: boolean = false;
  options = {
    displayField: 'title'
  };

  constructor(
    private route: ActivatedRoute,
    private parameterService: LiftBoardParameterService,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    this.liftId = +this.route.snapshot.paramMap.get('id');
    this.lift = this.route.snapshot.data.lift;

    let liftPermission = this.route.snapshot.data.liftPermission;
    if (!liftPermission) {
      liftPermission = [];
    }

    this.canViewErrors = liftPermission.indexOf('2') > -1 || this.loginService.isSuperadmin();
    this.canView = liftPermission.indexOf('0') > -1 || this.loginService.isSuperadmin();
    this.canControl = liftPermission.indexOf('3') > -1 || this.loginService.isSuperadmin();
    this.canViewParameter = liftPermission.indexOf('4') > -1 || this.loginService.isSuperadmin();

    this.loadGroup(this.lift.liftBoard.id);
  }

  loadGroup(boardId) {
    let criteria = new LiftBoardParameterCriteria();
    criteria.liftBoardId = boardId;
    criteria.orderby = 'Title asc';
    criteria.all = true;

    this.parameterService.get(criteria.paramsExport()).subscribe(response => {
      this.groups = response.body;
      this.groups = this.listToTree(this.groups);
    });

    
  }

  listToTree(list) {
    var map = {}, node, roots = [], i;
    for (i = 0; i < list.length; i += 1) {
      map[list[i].id] = i; // initialize the map
      list[i].children = []; // initialize the children
    }
    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.parentId !== null) {
        // if you have dangling branches check that map[node.parentId] exists
        node.title = node.liftParameter.code + ' '+ node.liftParameter.description;
        list[map[node.parentId]].children.push(node);
        list[map[node.parentId]].children.sort((a, b) => a.title.localeCompare(b.title));
      } else {
        roots.push(node);
      }
    }
    return roots;
  }

  onActivate($event) {
    if ($event.node.data.parentId != null) {
      this.selectedParam.liftParameter = $event.node.data.liftParameter;
      this.selectedParam.liftParameter.parsedValues = JSON.parse($event.node.data.liftParameter.values);     
    } else {
      this.selectedParam.liftParameter = {
        code: 'default',
        description: 'Není vybrán žádný parametr!',
        type: 3
      };
    }
  }

  loadParam() {

  }

  setParam() {

  }

  selectParam(p) {
    this.selectedParam = p;
    console.log(p);
  }

}
